import getApi from "../api/getApi";
import postApi from "../api/postApi";
import * as url from "../api/url";

export const getAllMachinesCategoryList = () => {
  return new Promise(async (resolve, reject) => {
    return getApi
      .get(url.GET_CATEGORY_LIST)
      .then((response) => {
        if (response) {
          resolve(response);
        }
      })
      .catch((err) => {
        reject(err.response);
      });
  });
};

export const getAllMachinesMaketList = (isFromAdvertisement = false) => {
  return new Promise(async (resolve, reject) => {
    return getApi
      .get(`${url.GET_MAKE_LIST}&isFromAdvertisement=${isFromAdvertisement}`)
      .then((response) => {
        if (response) {
          resolve(response);
        }
      })
      .catch((err) => {
        reject(err.response);
      });
  });
};

export const getAllMachinesModelList = (payload) => {
  return new Promise(async (resolve, reject) => {
    return postApi
      .post(url.GET_MODEL_LIST, payload)
      .then((response) => {
        if (response) {
          resolve(response);
        }
      })
      .catch((err) => {
        reject(err.response);
      });
  });
};

export const getMasterModelsByMake = (payload) => {

  return new Promise(async (resolve, reject) => {
    return postApi
      .post(url.GET_MASTER_MODELS_BY_MAKE, payload)
      .then((response) => {
        if (response) {
          resolve(response);
        }
      })
      .catch((err) => {
        reject(err.response);
      });
  });
};


const PAGE_SIZE = 100;

export const getAdIdByStableId = (stableId) => {
  const targetId = parseInt(stableId);

  const fetchPage = (pageNumber) =>
    postApi
      .post(url.GET_MACHINES_LIST, {
        ApplicationId: url.ApplicationId,
        PageNumber: pageNumber,
        PageSize: PAGE_SIZE,
        SearchKey: "",
        categoryIds: [],
        makeIds: [],
        models: [],
      })
      .then((response) => {
        const machines = response?.data?.machines || [];
        const totalRecords = response?.data?.TotalRecords || 0;

        const machine = machines.find((m) => m.id === targetId);
        if (machine?.assetAdvertisementId) return machine.assetAdvertisementId;

        const fetched = (pageNumber - 1) * PAGE_SIZE + machines.length;
        if (fetched < totalRecords) return fetchPage(pageNumber + 1);

        throw new Error("Machine not found");
      });

  return fetchPage(1).catch((err) => Promise.reject(err?.response || err));
};

export const getMachineDetailsByID = (assetId) => {
  return new Promise(async (resolve, reject) => {
    return getApi
      .get(url.GET_MACHINES_DETAILS + `&assetId=${assetId}`)
      .then((response) => {
        if (response) {
          resolve(response);
        }
      })
      .catch((err) => {
        reject(err.response);
      });
  });
};

export const postContactUs = (payload) => {
  return new Promise(async (resolve, reject) => {
    return postApi
      .post(url.POST_CONTACT_US, payload)
      .then((response) => {
        if (response) {
          resolve(response);
        }
      })
      .catch((err) => {
        reject(err.response);
      });
  });
};

export const getCategoryList = (header, instance, accounts) => {
  return new Promise(async (resolve, reject) => {
    return getApi
      .get(url.GET_CATEGORY_LIST_BY_ASSET, header, instance, accounts)
      .then((response) => {
        if (response) {
          resolve(response);
        }
      })
      .catch((err) => {
        reject(err.response);
      });
  });
};

export const saveLeadInfo = (payload, header) => {
  return new Promise(async (resolve, reject) => {
    return postApi
      .post(`${url.POST_SAVE_LEAD}`, payload, header)
      .then((response) => {
        if (response) {
          resolve(response);
        }
      })
      .catch((err) => {
        reject(err.response);
      });
  });
};
